import { useEffect, useRef } from "react";
import { Form } from "antd";
import dayjs from "dayjs";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import TextField from "@/common/elements/InputElements/TextField";
import { StyledGridCol, StyledGridRow, StyledSectionHeading } from "@/common/styles";
import useActiveWarrant from "@/hooks/useActiveWarrant";
import { getRefListNameByID } from "@/util/common_function";

const WarrantAdministrativeInformation = () => {
  const [form] = Form.useForm();
  const { activeWarrant, patch } = useActiveWarrant();
  const initializedRef = useRef(false);

  const patchField = (key, val) => patch({ [key]: val });

  const userDetails = JSON.parse(localStorage.getItem("userDetails"));

  const toDateString = (val) => {
    if (!val) return null;
    if (Array.isArray(val)) {
      const [y, m, d] = val;
      return `${String(m).padStart(2, "0")}/${String(d).padStart(2, "0")}/${y}`;
    }
    const parsed = dayjs(val);
    return parsed.isValid() ? parsed.format("MM/DD/YYYY") : null;
  };

  const toTimeString = (val) => {
    if (!val) return null;
    if (Array.isArray(val)) {
      const [h, m] = val;
      return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
    }
    if (typeof val === "string") return val;
    return null;
  };

  // Reset init guard when warrant changes
  const prevWarrantIdRef = useRef(null);
  useEffect(() => {
    const currentId = activeWarrant?.warrantId ?? activeWarrant?.warrantID ?? null;
    if (currentId !== prevWarrantIdRef.current) {
      initializedRef.current = false;
      prevWarrantIdRef.current = currentId;
    }
  }, [activeWarrant?.warrantId, activeWarrant?.warrantID]);

  useEffect(() => {
    if (!activeWarrant) return;
    if (initializedRef.current) return;
    initializedRef.current = true;

    // console.log("activeWarrant: ",activeWarrant);

    form.setFieldsValue({
      warrantId:  activeWarrant?.warrantId  ?? activeWarrant?.warrantID ?? null,
      dateAdded:  toDateString(activeWarrant?.dateAdded),
      timeAdded:  toTimeString(activeWarrant?.timeAdded),
      user: activeWarrant?.warrantId
        ? (activeWarrant?.creatorStaffId ? getRefListNameByID("", activeWarrant?.creatorStaffId, true, true) : null)
        : (userDetails?.staffDescriptionCached ?? userDetails?.username ?? null),
    });

    if(!activeWarrant?.warrantId) {
      patchField("creatorStaffID", userDetails?.staffId ?? null);
    }

  }, [activeWarrant]);

  return (
    <>
      <StyledSectionHeading>
        <span>Warrant Administrative Information</span>
      </StyledSectionHeading>

      {/* Always disabled — never editable */}
      <Form form={form} disabled>
        <StyledGridRow gutter={16}>
          <StyledGridCol lg={4}>
            <FormItem label="ID" name="warrantId">
              <TextField />
            </FormItem>
          </StyledGridCol>

          <StyledGridCol lg={6}>
            <FormItem label="Date Entered" name="dateAdded">
              <TextField />
            </FormItem>
          </StyledGridCol>

          <StyledGridCol lg={6}>
            <FormItem label="Time Entered" name="timeAdded">
              <TextField />
            </FormItem>
          </StyledGridCol>

          <StyledGridCol lg={6}>
            <FormItem label="User" name="user">
              <TextField />
            </FormItem>
          </StyledGridCol>
        </StyledGridRow>
      </Form>
    </>
  );
};

export default WarrantAdministrativeInformation;